import HeightsArea from './model/heights-area';

export class HeightsEditState {
  areas = [];
  rawAreas = [];

  constructor(options = {}) {
    ({
      rawAreas: this.rawAreas = [],
      initialMinHeight: this.initialMinHeight,
      initialSlope: this.initialSlope,
    } = options);

    const rawAreas = this.rawAreas.filter(area => !area.iscutout);
    const allCutouts = this.rawAreas.filter(area => !!area.iscutout);
    for (const rawArea of rawAreas) {
      this.areas.push(
        new HeightsArea(
          { ...rawArea, initialMinHeight: this.initialMinHeight, slope: this.initialSlope, parent: this },
          allCutouts
        )
      );
    }
  }

  removePoint(heightPoint) {
    const area = heightPoint.parent;
    area.removePoint(heightPoint);
  }

  get isValid() {
    return this.areas.every(area => area.isValid);
  }

  get hasSomeHeightpointChanged() {
    return !this.allHeightPoints.every(point => point.height === this.initialMinHeight);
  }

  get isLowestPointHigherThenInitialMinHeight() {
    return this.allHeightPoints.every(point => point.height > this.initialMinHeight);
  }

  clearPointHighlights() {
    this.areas.forEach(area => {
      area.heightPoints.forEach(point => (point.highlighted = false));
    });
  }

  get minHeight() {
    return Math.min(...this.areas.map(area => area.minHeight));
  }

  get maxHeight() {
    return Math.max(...this.areas.map(area => area.maxHeight));
  }

  get heightRange() {
    return { min: this.minHeight, max: this.maxHeight };
  }

  get backendObjects() {
    return this.areas
      .map(area => area.backendObjects)
      .flat()
      .sort((a, b) => {
        return a.area_cf_index - b.area_cf_index;
      });
  }

  get allSlopesDefined() {
    return this.areas.every(area => area.slopeDefined);
  }

  isThePointLastOneWithMinHeight(point) {
    return this.allMinHeightPoints.includes(point) && this.allMinHeightPoints.length === 1;
  }

  areAllMinHeightPoinstAmong(points) {
    return this.allMinHeightPoints.every(point => points.includes(point));
  }

  get allMinHeightPoints() {
    return [...this.areas.map(area => area.minHeightPoints)].flat();
  }

  get allHeightPoints() {
    return [...this.areas.map(area => area.heightPoints)].flat();
  }
}
